import React, {Component} from 'react';
import * as messageConstants from '../../shared/messages';
import KeyLengthModal from './KeyLengthModal';

class KeyLengthSelector extends Component {
  state = {
    showModalKeyLengthConfirmation: false,
    pendingKeyLength: undefined
  }

  handleShowModalKeyLengthConfirmation = (len) => {
    const {keyLength} = this.props;
    if (len === keyLength) {
      return;
    }
    this.setState({
      showModalKeyLengthConfirmation: true,
      pendingKeyLength: len
    });
  }

  handleHideModalKeyLengthConfirmation = () => {
    this.setState({
      showModalKeyLengthConfirmation: false,
      pendingKeyLength: undefined
    });
  }

  handleConfirmKeyLength = () => {
    const {pendingKeyLength} = this.state;
    if (pendingKeyLength) {
      console.log(`Changing key length to ${pendingKeyLength}`);
      this.props.onChange(pendingKeyLength);
      this.setState({
        showModalKeyLengthConfirmation: false,
        pendingKeyLength: undefined
      });
    }
  }

  render() {
    const {keySize} = this.props;
    const {showModalKeyLengthConfirmation, pendingKeyLength} = this.state;
    return (
      <div>
        <h3>{messageConstants.CERTIFICATE_KEY_HEADER}
        </h3>
        <div className="key-length-row">
          {(keySize === 2048 || keySize === 4096) && (
              <div>
                <span>
                  {keySize === 2048 ? messageConstants.KEY_LENGTH_2048 : messageConstants.KEY_LENGTH_4096}
                </span>
                <span className="key-length-separator"></span>
                <button
                    type="button"
                    className="btn btn-link"
                    onClick={() =>
                        this.handleShowModalKeyLengthConfirmation(keySize === 2048 ? 4096 : 2048)
                    }
                >
                  Use {keySize === 2048 ? 4096 : 2048} bits
                </button>
              </div>
          )}
        </div>
        <KeyLengthModal
          showModalKeyLengthConfirmation={showModalKeyLengthConfirmation}
          pendingKeyLength={pendingKeyLength}
          handleHideModalKeyLengthConfirmation={this.handleHideModalKeyLengthConfirmation}
          handleConfirmKeyLength={this.handleConfirmKeyLength}
        />
      </div>
    );
  }
}

export default KeyLengthSelector;
